import React, { useEffect, useState } from 'react'
import { Base, CheckIcon } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import { useRequestUploadDocs } from '@/hooks'

const {
  Button,
  Textarea,
  DialogRoot,
  DialogPortal,
  DialogBackdrop,
  DialogPopup,
  DialogTitle,
  DialogDescription,
  DialogCloseButton,
  DialogHeader,
  DialogFooter
} = Base

interface RequestDocumentsModalProps {
  isOpen: boolean
  onRequestClose: () => void
  processId: string
}

const RequestDocumentsModal: React.FC<RequestDocumentsModalProps> = ({
  isOpen,
  onRequestClose,
  processId
}) => {
  const { t } = useTranslation()
  const [description, setDescription] = useState('')
  const {
    mutate: requestUploadDocs,
    isPending: loadingRequestUploadDocs,
    isSuccess: successRequestUploadDocs
  } = useRequestUploadDocs()

  useEffect(() => {
    if (successRequestUploadDocs) {
      setTimeout(() => {
        onRequestClose()
      }, 2000)
    }
  }, [successRequestUploadDocs])

  return (
    <DialogRoot
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onRequestClose()
      }}
    >
      <DialogPortal>
        <DialogBackdrop />
        <DialogPopup>
          <div className="w-[30rem]">
            <DialogCloseButton />
            <div className="space-y-3">
              <DialogHeader>
                <DialogTitle>
                  {t('process_details_page.request_docs')}
                </DialogTitle>
                <DialogDescription>
                  {t('request_photos_modal.description')}
                </DialogDescription>
              </DialogHeader>
              <div className="space-y-6">
                <Textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  rows={3}
                  className="resize-none font-sans"
                  name="request-docs-description"
                  id="request-docs-description"
                  placeholder={t('request_photos_modal.text_placeholder')}
                />
                <DialogFooter>
                  <Button
                    type="button"
                    variant="secondary"
                    onClick={onRequestClose}
                  >
                    {t('process_details_page.report_incident.cancel_button')}
                  </Button>
                  <Button
                    type="button"
                    variant="primary"
                    onClick={() => {
                      if (!processId) return
                      requestUploadDocs({ processId, message: description })
                    }}
                    loading={loadingRequestUploadDocs}
                    disabled={successRequestUploadDocs}
                  >
                    {successRequestUploadDocs ? (
                      <>
                        <CheckIcon className="size-4" />
                        {t('process_details_page.pictures_requested')}
                      </>
                    ) : (
                      t('process_details_page.request_docs')
                    )}
                  </Button>
                </DialogFooter>
              </div>
            </div>
          </div>
        </DialogPopup>
      </DialogPortal>
    </DialogRoot>
  )
}

export default RequestDocumentsModal
